class Sidebar {
    constructor() {
        this.sidebar = null;
        this.overlay = null;
        this.sidebarTrigger = null;
    }
    openSidebar() {
        this.sidebar?.classList.add('active');
        this.overlay?.classList.add('active');
    }
    enableSidebar() {
        try {
            this.sidebarTrigger = document.querySelector('#sidebarCollapse');
            this.sidebar = document.querySelector('.sidebar');
            this.overlay = document.querySelector('#sidebarOverlay');
            if (!(this.sidebar && this.sidebarTrigger && this.overlay)) {
                throw new Error('Cannot find at least one of sidebar elements');
            }
            this.sidebarTrigger?.addEventListener('click', () => this.openSidebar());
            this.overlay?.addEventListener('click', this.hideSidebar);
        }
        catch (error) {
        }
    }
    disableSidebar() {
        try {
            this.sidebarTrigger?.removeEventListener('click', () => this.openSidebar());
            this.overlay?.removeEventListener('click', this.hideSidebar);
        }
        catch (error) {
        }
    }
    hideSidebar() {
        try {
            const sidebar = document.querySelector('.sidebar');
            const overlay = document.querySelector('#sidebarOverlay');
            sidebar?.classList.remove('active');
            overlay?.classList.remove('active');
        }
        catch (error) {
        }
    }
}
const sidebar = new Sidebar();
export default sidebar;
